// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds.
export default function debounce(fn, delay) {
    var timer = null;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}

export function toggleReadmoreText(container) {
  container.querySelectorAll('.js-readmore-par').forEach((el, i) => {
    el.classList.toggle('js-hidden');
  });
}


/*
 * Usage
 *
 *  @param { object | element node } $button - Clicked Element, from delegated event listener.
 *  @return { Null | Undefined}
 *
 * */
export function toggleAccordion(button) {
  document.querySelectorAll('.js-accordion-item').forEach((el, i) => {
    if( !el.contains(button) ) return;
    el.classList.toggle('js-open');
  });
}

export function makeLastBold(textEl) {
  const wordArray = textEl.innerHTML.split(" "); // [word, word]
  const newArray = [];
  wordArray.forEach( ( el,i ) => {
    let lightWord = wordArray[i];
    if(i===0){
      lightWord = '<h1 class="title--across">' + wordArray[i];
    }else if(i===wordArray.length-1){
      lightWord = '</h1>' + '<h1 class="title--across"> ' + wordArray[i] + ' </h1>';
    }
    newArray.push(lightWord);
  } );
  textEl.innerHTML = newArray.join(" ").toString();
}

export function stylePageTitle(textEl) {
  const wordArray = textEl.innerHTML.split(" "); // [word, word]
  const newArray = [];
  wordArray.forEach( ( el,i ) => {
    let lightWord = wordArray[i];
    if(i===0){
      lightWord = '<span class="title--center">' + wordArray[i];
    }else if(i===wordArray.length-1){
      lightWord = '</span>' + '<span class="title--center"> ' + wordArray[i] + ' </span>';
    }
    newArray.push(lightWord);
  } );
  textEl.innerHTML = newArray.join(" ").toString();
}

export function headerSpanner(textEl) {
  const wordArray = textEl.innerHTML.split(" "); // [word, word]
  const newArray = [];
  wordArray.forEach( ( el,i ) => {
    let lightWord = wordArray[i];
    lightWord = '<span class="title--part">' + wordArray[i] + ' </span>';
    newArray.push(lightWord);
  } );
  textEl.innerHTML = newArray.join(" ").toString();
}
